// The log WebSocket checks its token only when it connects (spec 2026-10-15
// §4.2), so a reconnect must not offer one that is about to expire. Keycloak
// access tokens live 5 min: renew first when under 60 s are left.
export const RENEW_BEFORE_SECONDS = 60;

export async function tokenForConnect(d: {
  keycloak: boolean;
  getUser: () => Promise<{ expires_in?: number; expired?: boolean } | null>;
  token: () => Promise<string | null>;
  renew: () => Promise<boolean>;
}): Promise<string | null> {
  if (d.keycloak) {
    const user = await d.getUser();
    const left = user?.expires_in;
    if (!user || user.expired || left === undefined || left < RENEW_BEFORE_SECONDS) {
      await d.renew();
    }
  }
  return d.token();
}
